import { render } from "./Notification-items.vue?vue&type=template&id=4dfd5742&scoped=true"
import script from "./Notification-items.vue?vue&type=script&lang=js"
export * from "./Notification-items.vue?vue&type=script&lang=js"

import "./Notification-items.vue?vue&type=style&index=0&id=4dfd5742&lang=scss&scoped=true"

import exportComponent from "/home/douglas/Documents/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dfd5742"]])

export default __exports__